export default {
    report: 'Report',
    dailyReport: 'Daily Report',
    monthlyReport: 'Monthly Report',
    empMonthlyLogReport: 'Employee Monthly Log Report',
    monthlyRecordingReport: 'Monthly Recording Report',
    OvertimeMonthlyReport: 'Overtime Report',
    allBranch: 'All Branch',
    attendanceReport: 'Attendance',
    visitorReport: 'Visitor activity'
}
